<script>
// Р10 п.15: вкладка «Настройка ИИ-агента» управляет НАШИМ ИИ-агентом
// (Assistant::Agent) канала — раньше здесь был выбор нативных webhook-ботов,
// которых в продукте нет, и селект всегда был пуст.
import { useAlert } from 'dashboard/composables';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SelectInput from 'dashboard/components-next/select/Select.vue';
import AssistantAgentsAPI from 'dashboard/api/assistant/agents';
import AssistantInboxesAPI from 'dashboard/api/assistant/inboxes';

export default {
  components: {
    LoadingState,
    SettingsFieldSection,
    NextButton,
    SelectInput,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      aiAgents: [],
      selectedAgentId: null,
      savedAgentId: null,
      isFetching: false,
      isSaving: false,
      isDisconnecting: false,
    };
  },
  computed: {
    currentInboxId() {
      return Number(this.inbox?.id || this.$route.params.inboxId);
    },
    agentOptions() {
      return this.aiAgents.map(agent => ({
        value: agent.id,
        label: agent.name,
      }));
    },
  },
  watch: {
    currentInboxId() {
      this.fetchAgents();
    },
  },
  mounted() {
    this.fetchAgents();
  },
  methods: {
    async fetchAgents() {
      this.isFetching = true;
      try {
        const { data } = await AssistantAgentsAPI.get({
          kind: 'customer_agent',
        });
        this.aiAgents = data.payload || [];
        const current = this.aiAgents.find(agent =>
          (agent.inbox_ids || []).includes(this.currentInboxId)
        );
        this.selectedAgentId = current ? current.id : null;
        this.savedAgentId = this.selectedAgentId;
      } catch (error) {
        this.aiAgents = [];
      } finally {
        this.isFetching = false;
      }
    },
    async updateActiveAgent() {
      if (this.selectedAgentId === this.savedAgentId) return;
      this.isSaving = true;
      try {
        if (this.savedAgentId) {
          await AssistantInboxesAPI.delete({
            agentId: this.savedAgentId,
            inboxId: this.currentInboxId,
          });
        }
        if (this.selectedAgentId) {
          await AssistantInboxesAPI.create({
            agentId: this.selectedAgentId,
            inboxId: this.currentInboxId,
          });
        }
        this.savedAgentId = this.selectedAgentId;
        useAlert(this.$t('AGENT_BOTS.BOT_CONFIGURATION.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(
          error?.message ||
            this.$t('AGENT_BOTS.BOT_CONFIGURATION.ERROR_MESSAGE')
        );
      } finally {
        this.isSaving = false;
      }
    },
    async disconnectAgent() {
      if (!this.savedAgentId) return;
      this.isDisconnecting = true;
      try {
        await AssistantInboxesAPI.delete({
          agentId: this.savedAgentId,
          inboxId: this.currentInboxId,
        });
        this.savedAgentId = null;
        this.selectedAgentId = null;
        useAlert(
          this.$t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECTED_SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          error?.message ||
            this.$t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECTED_ERROR_MESSAGE')
        );
      } finally {
        this.isDisconnecting = false;
      }
    },
  },
};
</script>

<template>
  <div class="mx-6 max-w-4xl">
    <LoadingState v-if="isFetching" />
    <form v-else @submit.prevent="updateActiveAgent">
      <SettingsFieldSection
        :label="$t('AGENT_BOTS.BOT_CONFIGURATION.TITLE')"
        :help-text="$t('AGENT_BOTS.BOT_CONFIGURATION.DESC')"
        class="[&>div]:!items-start"
      >
        <SelectInput
          v-model="selectedAgentId"
          :placeholder="$t('AGENT_BOTS.BOT_CONFIGURATION.SELECT_PLACEHOLDER')"
          :options="agentOptions"
        />
        <p v-if="!aiAgents.length" class="mt-2 text-sm text-n-slate-11">
          {{ $t('AGENT_BOTS.BOT_CONFIGURATION.EMPTY') }}
        </p>
        <template #extra>
          <div class="grid grid-cols-1 lg:grid-cols-8 mt-3">
            <div class="col-span-1 lg:col-span-2 invisible" />
            <div class="col-span-1 lg:col-span-6 flex gap-2 mx-1">
              <NextButton
                type="submit"
                :label="$t('AGENT_BOTS.BOT_CONFIGURATION.SUBMIT')"
                :is-loading="isSaving"
              />
              <NextButton
                type="button"
                :disabled="!savedAgentId"
                :is-loading="isDisconnecting"
                faded
                ruby
                @click="disconnectAgent"
              >
                {{ $t('AGENT_BOTS.BOT_CONFIGURATION.DISCONNECT') }}
              </NextButton>
            </div>
          </div>
        </template>
      </SettingsFieldSection>
    </form>
  </div>
</template>
